import { Box, Text } from '@factorialco/deprecated-design-system'

import type { BenefitItem } from 'modules/benefits/pages/BenefitsLanding/_Content/countryContent'

interface BenefitCardRightProps {
  benefit: BenefitItem
}

const BenefitCardRight = ({ benefit }: BenefitCardRightProps) => {
  return (
    <Box className="flex-col-reverse items-center md:flex-row" gap="s24">
      <Box gap="s16" className="w-full md:w-1/2 px-6">
        <Box className="">
          <Text size="400" weight="semibold" color="black">
            {benefit.title}
          </Text>
        </Box>
        <Box className="">
          <Text size="300">{benefit.description}</Text>
        </Box>
      </Box>
      <Box borderRadius={{ all: 'abs016' }} overflowX="hidden" className="w-full md:w-1/2">
        <video
          src={benefit.media.src}
          style={{ width: '100%', height: 'auto', display: 'block' }}
          autoPlay
          muted
          loop
        />
      </Box>
    </Box>
  )
}

export default BenefitCardRight
